export default "__VITE_ASSET__D0Tr70fN__"